import { render, staticRenderFns } from "./RestoreSet.vue?vue&type=template&id=c17aa822&scoped=true&lang=pug"
import script from "./RestoreSet.vue?vue&type=script&lang=js"
export * from "./RestoreSet.vue?vue&type=script&lang=js"
import style0 from "./RestoreSet.vue?vue&type=style&index=0&id=c17aa822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17aa822",
  null
  
)

export default component.exports